import ATSSALogo from "./../Assets/logos/ATSSA logo.jsx";
import NYCBLogo from "./../Assets/logos/NYC_buildings logo.jsx";
import OSHALogo from "./../Assets/logos/osha logo.jsx";
import IACETLogo from "./../Assets/logos/IACET_logo.png";
import NCCERLogo from "./../Assets/logos/nccer logo.png";


export const pics = [
  require("./..\\Assets\\images\\classes\\IMG_2392.jpg"),
  require("./..\\Assets\\images\\classes\\IMG_2510.jpg"),
  require("./..\\Assets\\images\\classes\\IMG_2652.jpg"),
  require("./..\\Assets\\images\\classes\\IMG_3200.jpg"),
  require("./..\\Assets\\images\\classes\\IMG_3311.jpg"),
  require("./..\\Assets\\images\\classes\\IMG_7647.jpg"),
  require("./..\\Assets\\images\\classes\\IMG_7650.jpg")
]

export const agencyInfo = [
  {
    name: 'IACET',
    description: 'The International Accreditors for Continuing Education and Training (IACET) developed the original Continuing Education Unit (CEU) and today ensures that providers of continuing education and training can prove they provide high-quality instruction by following the ANSI/IACET 2018-1 Standard for Continuing Education and Training through a rigorous accreditation process.',
    classesAvailable: false,
    logo: IACETLogo
  },
  {
    name: 'OSHA',
    description: 'With the Occupational Safety and Health Act of 1970, Congress created the Occupational Safety and Health Administration (OSHA) to ensure safe and healthful working conditions for working men and women by setting and enforcing standards and by providing training, outreach, education and assistance.',
    classesAvailable: true,
    logo: <OSHALogo alt={`OSHA courses`} />
  },
  {
    name: 'ATSSA',
    description: 'ATSSA was incorporated in 1970 as an International Trade Association. ATSSA is a member partnership comprised of approximately 1,500 companies representing over 11,000 industry professionals in the sign manufacturing, pavement marking, guardrail and barrier, traffic services, and traffic signals technical divisions.',
    classesAvailable: true,
    logo: <ATSSALogo alt={`ATSSA courses`} />
  },
  {
    name: 'DOB',
    description: 'The Department of Buildings promotes the safety of all people that build, work, and live in New York City by regulating the lawful use of over one million buildings and construction sites across the five boroughs. With a focus on safety, service, and integrity, the Department enforces the City’s Construction Codes, Zoning Resolution, and the New York State Multiple Dwelling Law.',
    classesAvailable: true,
    logo: <NYCBLogo alt={`DOB courses`} />,
    learnMore: ["NYC Local Law 196 requires construction workers at most major jobsites to have 40 hours of DOB-approved Site Safety Training. Workers must complete this training to earn an SST Worker card, which is now needed to enter any New York City jobsite with a Site Safety Plan.", "This 40-hour course package includes 30-Hour OSHA Outreach training, SST 8-Hour Fall Prevention, 2-Hour Mental Health Awareness and an official SST card printed on durable plastic. It is designed for workers who need to complete both OSHA training and SST, including new workers and those who completed OSHA training more than five years ago.", "You will receive your plastic, wallet-sized SST Worker card which is included in the course price."]
  },
  {
    name: 'NCCER',
    description: 'NCCER is a not-for-profit 501(c)(3) education foundation created in 1996 as The National Center for Construction Education and Research. It was developed with the support of more than 125 construction CEOs and various association and academic leaders who united to revolutionize training for the construction industry.',
    classesAvailable: false,
    logo: NCCERLogo
  },
]
